import { useQuery } from '@tanstack/react-query';
import { StoresApiAdapter } from '../adapters';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

interface UseStoresParams {
  tenantChildId?: number;
  enabled?: boolean;
}

const httpClient = createHttpClient(apiClientWH);
const storesAdapter = new StoresApiAdapter(httpClient);

export const useStores = ({
  tenantChildId,
  enabled = true,
}: UseStoresParams = {}) => {
  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['order-create-stores', tenantChildId ?? 'all'],
    queryFn: () => storesAdapter.getAll({ tenantChildId }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    stores: data ?? [],
    loading: enabled ? isLoading || isFetching : false,
    error: error instanceof Error ? error.message : null,
    refetch,
  };
};
